module.exports = react_production_lib;